import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, ReplaySubject } from 'rxjs';
import { ApiService } from '../../shared/services';
import { environment } from '../../../environments/environment';
import { IUserDetails, ILoginDetails, IUser,User,IGlobalFilter, IRequirementRefId, IForgotPassword, IResetPassword } from '../models/user.model';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../services/jwt.service';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  private currentUserSubject = new BehaviorSubject<User>({} as User);
  public currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();
  tmp_permissions : string;
  permissions: string[];

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private jwtService: JwtService,
    private router: Router
  ) { }

  public userLogin(value: ILoginDetails): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    // return this.http.post<any>(`${environment.apiRoot}ApplicationUser/Login`, value, { headers });
    return this.apiService.post('ApplicationUser/Login', value);
  }

  public checkUserName(userName:string): Observable<any> {
   
    return this.http.get<any>(`${environment.apiRoot}UserProfiles/CheckUserName/${userName}`);
  }

  public verifyCompanySubmit(userName:string): Observable<any> {
    return this.http.get<any>(`${environment.apiRoot}UserProfiles/VerifyCompanySubmit/${userName}`);
  }
  
  getUserProfile(userName:string):Observable<IUser> {
    // return this.http.get<IUser>(`${environment.apiRoot}UserProfile/GetUserDetails?userName=${userName}`);
    return this.apiService.getInd(`UserProfile/GetUserDetails?userName=${userName}`);
  }

  public createUser(value: IUserDetails): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<any>(`${environment.apiRoot}ApplicationUser/Register`, value, { headers });
  }

  public resetPassword(value:IResetPassword):Observable<any>{
    return this.apiService.post(`UserProfiles/ResetPassword`,value);
  }


  public forgotPassword(value: IForgotPassword): Observable<any> {
    return this.apiService.post(`UserProfiles/ForgotPassword`, value);
  }

  // public getRequirement(pageNo:number,pageSize:number,totalFilter:string,sortField:string,sortOrder:string): Observable<Requirements> {
  //   return this.http.get<Requirements>(`${environment.apiRoot}Requirement/GetRequirementDetails?pageNo=${pageNo}&pageSize=${pageSize}
  //   &totalFilter=${totalFilter}&sortField=${sortField}&sortOrder=${sortOrder}`);
  // }
  

  

  public activateUser(userName:string):Observable<any>{
    return this.http.get<any>(`${environment.apiRoot}UserProfile/ActivateUser?userName=${userName}`);
  }
  public deactivateUser(userName:string):Observable<any>{
    return this.http.get(`${environment.apiRoot}UserProfile/DeactivateUser?userName=${userName}`);
  }

  public getUsers(pageNo:number,pageSize:number,totalFilter:string,sortField:string,sortOrder:string): Observable<any> {
    return this.http.get<any>(`${environment.apiRoot}UserProfile/GetAllUserDetails?pageNo=${pageNo}&pageSize=${pageSize}&totalFilter=${totalFilter}&sortField=${sortField}&sortOrder=${sortOrder}`);
  }
  
  public uploadUsers(fileToUpload:any) {
    let input = new FormData();
    input.append("file", fileToUpload);
    return this.http.post<any>(`${environment.apiRoot}ApplicationUser/UploadUsers`,input);
  } 
  public uploadCompanies(value:IUserDetails[]):Observable<any> {
    return this.http.post<any>(`${environment.apiRoot}UserProfile/UploadCompanies`,value);
  }
  public uploadValidUsers(value:IUserDetails[]):Observable<any> {
    return this.http.post<any>(`${environment.apiRoot}UserProfile/UploadActiveUsers`,value);
  }
  public getReqtest(allFilters :string): Observable<any> {
    //var filter = totalFilter;
    console.log("all",allFilters);
    return this.http.get(`${environment.apiRoot}Requirement/GetRequirementDetailsTest?`);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<any>(`${environment.apiRoot}Requirement/GetRequirementDetailsTest`,allFilters,{headers});
  }
  roleMatch(allowedRoles:any):boolean {
    var isMatch= false;
    var payLoad=JSON.parse(window.atob(localStorage.getItem('token').split('.')[1]));
    console.log(payLoad.role);
    var userRole= payLoad.role;
    allowedRoles.forEach(element => {
      if(userRole == element)
      { 
        isMatch = true;
        return false;
      }
     
    });
    return isMatch;
  }

  populate() {
    // If JWT detected, attempt to get & store user's info
    if (this.jwtService.getToken()) {
      this.apiService.get('/user')
      .subscribe(
        data => this.setAuth(data.user),
        err => this.purgeAuth()
      );
    } else {
      // Remove any potential remnants of previous auth states
      this.purgeAuth();
    }
  }

  setAuth(user: User) {
    // Save JWT sent from server in localstorage
    this.jwtService.saveToken(user.auth_token);
    user = this.jwtService.decodeToken(user.auth_token);
    // Set current user data into observable
    this.currentUserSubject.next(user);
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);
  }

    purgeAuth() {
        
    // Remove JWT from localstorage
    this.jwtService.destroyToken();
    // Set current user to an empty object
    this.currentUserSubject.next({} as User);
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);
    this.router.navigateByUrl('');
  }

  attemptAuth(type, credentials): Observable<User> {
    const route = (type === 'login') ? 'token' : '';
    return this.apiService.postAuth(route, credentials)
      .pipe(map(
        data => {
          //console.log(data);
        this.setAuth(data);
        return data;
      }
    ));
  }

  getCurrentUser(): User {
    return this.currentUserSubject.value;
  }
  getUserPermissions(): string[] {
    this.tmp_permissions = this.jwtService.getPermissions();
    this.permissions = this.tmp_permissions.split(',');    
    return this.permissions;
  }
  getLoggedInUserProfile(): User {
    return this.jwtService.getLoggedInUserProfile();
  }

  getLoggedInUserProfileId(){
    return this.jwtService.getLoggedInUserProfileId();
  }
  getLoggedInUserRoles(){
    return this.jwtService.getRoles();
  }

  public EmailUnsubscribe(userProfileReferenceId:string,userName:string):Observable<any>{
    return this.http.get(`${environment.apiRoot}UserProfiles/EmailUnsubscribe/${userProfileReferenceId}/${userName}`);
  }
  public checkDvmsSystemAlertByPageId(pageId:number):Observable<any>{
    return this.apiService.get(`UserProfiles/CheckDvmsSystemAlertByPageId/${pageId}`);
  } 
}
